import { makeAutoObservable } from 'mobx'
import { PositionType, TechStack } from 'types/common'
import { findIndex } from 'lodash-es'

const STEP_DATA = [
  { progress: 1, question: '현재 경력이 어떻게 되시나요?' },
  { progress: 2, question: '어떤 포지션으로 제안받고 싶으세요?' },
  { progress: 3, question: '원하시는 기술이 있으신가요?' },
]

export class ScoutCalculatorStore {
  stepIndex: number = 0
  experience: number = 0
  positionTypes: PositionType[] = []
  techStacks: TechStack[] = []
  isCalculated: boolean = false

  constructor() {
    makeAutoObservable(this)
  }

  get isLastStep() {
    return this.stepIndex >= STEP_DATA.length - 1
  }

  get step() {
    return STEP_DATA[this.stepIndex]
  }

  get isAbleToNext() {
    if (this.step.progress === 2 && this.positionTypes.length === 0)
      return false
    return true
  }

  get positionTypeIds() {
    return this.positionTypes.map((p) => p.id)
  }

  get user() {
    return {
      name: '인재',
      image: '',
      experience: this.experience,
      interestedPositionTypes: this.positionTypes,
      interestedTechStacks: this.techStacks,
    }
  }

  setStepIndex(index: number) {
    this.stepIndex = index
  }

  setIsCalculated(v: boolean) {
    this.isCalculated = v
  }

  setExperience(experience: number) {
    this.experience = experience
  }

  setPositionTypes(p: PositionType[]) {
    this.positionTypes = p
  }

  togglePositionType(p: PositionType) {
    const index = findIndex(
      this.positionTypes,
      (positionType) => positionType.id === p.id,
    )
    if (index >= 0) {
      this.positionTypes.splice(index, 1)
    } else {
      this.positionTypes.push(p)
    }
  }

  setTechStack(t: TechStack) {
    const techStackId = this.techStacks.map((item) => item.id)
    if (techStackId.includes(t.id)) {
      this.techStacks = this.techStacks.filter((item) => item.id !== t.id)
    } else this.techStacks.push(t)
  }

  deleteTechStack(t: TechStack) {
    this.techStacks = this.techStacks.filter((item) => item !== t)
  }
}
